import Styled from 'styled-components/macro';

export const WidgetWrapper = Styled.div`
    width: 526px;
    height: 308px;    
    border: 1px solid #E6E6ED;
    box-sizing: border-box;
    border-radius: 4px;
    margin-right: 44px;
    margin-bottom: 44px;
    padding: 22px;
`;

export const Title = Styled.div`
  align: right;
  width: 500px;
  height: 17px;
  padding-right: 22px;
  
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  
  /* Typography/Light/Disabled */
  
  color: #C4C4CC;
`;

export const Content = Styled.div`
  padding: 22px;
`;
